import Map from '../../Map';
import Panel from './Events/Panel';
import Close from './Events/Close';
import Icon from './Partials/Icon';
import Filters from './Events/Filters';
import InfoWindow from  './Partials/infoWindow';
import ComunasRegiones from './Events/ComunasRegiones';

export default class {

    constructor() 
    {
        ( new ComunasRegiones() );
        
        const centerMap  = {lat:'-33.451301574707',lng:'-70.665298461914'}

        this.map      = new Map('mapServiceStation',centerMap,this);
        var stationsAll  = window.stations;
        var stations     = stationsAll;

        this.map.then( this.renderAllLocations );
        
        this.services = [
            'Kero',
            'GNC',
            'GLP',
            'CajeroAutomatico',
            'Banno',
            'Duchas',
            'TarjetaFlota',
            'EstacionamientoCamiones',
            'Wifi',
            'PES',
            'DescuentoTaxi',
            'TieneLubricacion',
            'tieneRipley',
            'tieneJohnsons',
            'tieneLaPolar',
            'tieneABCDin',
            'tieneHites',
            'tieneCorona',
        ];

        this.infoWindow        = document.getElementById('infoWindow');
        this.contentInfowindow = document.getElementById('content-infowindow');

        ( new Close() );
        ( new Panel() );

        console.log(this.stations);
    }

    renderAllLocations( object )
    {
        
        const {google,map,that} = object;
        const markers = new Array();

        let marker;

        stations.forEach( station => {

            if( station['Estado'] === 'true' )
            {
                marker = new google.Marker({
                    position : new google.LatLng( station.Latitud,station.Longitud),
                    map      : map,
                    icon     : '/wp-content/themes/dt-the7-child/assets/icons/marker.png',
                    title    : station['NombreEstacion'],
                })

                markers.push(marker);

                google.event.addListener(marker, 'click', (function (marker) {

                    let services = that.determineServices(station);

                    return function ()
                    {                
                        that.setContent( that.printInfoWindow(station,services) ,that.contentInfowindow );
                        that.open();
                    }
                })(marker));
            }

        });

        ( new Filters(google,map,markers,that.services) );

    }

    setContent( info,contentInfowindow )
    {
        contentInfowindow.innerHTML = info;
    }


    printInfoWindow( station,services )
    {
        return InfoWindow.render(station,services);
    }

    printIcon( key )
    {
        return  Icon.render( key );
    }

    determineServices( station )
    {
        let services = '';

        this.services.forEach ( service => {

            if( station[service] === 'true' )
            {
                services += this.printIcon(service);
            }

        },this);

        if( station['Lubrax'] == '1' )
        {
            services += this.printIcon('Lubrax')
        }

        if( station['EstadoTienda'] == 'true' )
        {
            switch (station['TipoTienda']) {
                case 'Full':
                    services += this.printIcon('icon-tienda-full');
                    break;
            
                default:
                    services += this.printIcon('icon-tienda-self');
                    break;
            }
        }

        if( station['FormatoLavado'] == 'Acuocenter – Full' )
        {
            services += this.printIcon('new-icon-lavado');
        }	

        if( station['FormatoLavado'] == 'Acuocenter – Self' )
        {
            services += this.printIcon('autolavado-nuevo');
        }		
        
        if( station['EstadoIsla'] == 'Operando' )
        {
            switch ( station['TipoIsla'] )
            {
                case 'Full':
                    services += this.printIcon('icon-isla-full');
                    break;
                case 'Mixto':
                    services += this.printIcon('icon-isla-mixto');
                    break;            
                default:
                    services += this.printIcon('icon-isla-self');
                    break;
            }
        }

        

        return services;
    }

    open()
    {
        this.infoWindow.style.display = 'block';
    }

}
